/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SimpleFilterEntitySchemaMode } from './simpleFilterEntitySchemaMode';

/**
 * Shape for filter lists that aren't canonicalized today (languages,
 * majors, investors, company_tags, power_filters, highlight_types).
 *
 * Replaces the old `list[str]` shape so each entry can carry `required`
 * and `mode` flags consistent with the canonicalized filter entities.
 */
export interface SimpleFilterEntitySchema {
  text: string;
  required?: boolean;
  mode?: SimpleFilterEntitySchemaMode;
}
